import { ApiAction } from 'redux-upgrader'

export const VALIDATE_TOKEN = new ApiAction('VALIDATE_TOKEN')
